import { useEffect, useRef } from "react";
import { useState } from "react";
import { CommonUtil } from "../../../../util/CommonUtil";
import { createLogger } from "../../../../utils/logger";
import {
  //useLoaderData,
  useLocation,
  //useNavigate
  //useOutletContext
} from "react-router-dom";
import {
  Note,
  //NotebookDetailsLoader
} from "../../../../model/models";
import OffcanvasNotes from "./OffcanvasNotes";
import LazyEditor from "./LazyEditor";

import { useDispatch, useSelector } from "react-redux";

import { storeNotebook } from "../../../../slice/notebookSlice";
import {
  storeNotes,
  //addNoteToNotes
} from "../../../../slice/notesSlice";

import ToastMessage from "./ToastMessage";
import {
  faSquarePlus,
  faCloudArrowUp,
  faCheckCircle,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import NoteView from "./notes/NoteView";
let currentNotebook;

import { notebookService } from "../../../../App";
import LastNotes from "./notebook/LastNotes";
import {handleClick} from "../../../../slice/clicksSlice";
import LTButton from "./LTButton";

const logger = createLogger('NotebookDetailsPage');

const NotebookDetailsPage = () => {

  //for new note
  const [note, setNote] = useState<Partial<Note> | undefined>({
    name: "",
    text: "",
  });
  const [messageText, setMessageText] = useState({
    show: false,
    title: "",
    message: "",
  });
  const [processing, setProcessing] = useState(false);
  const [keyEditor, setKeyEditor] = useState(5000);
  const [enableEditNote, setEnableEditNote] = useState(false);
  const [noteChange, setNoteChance] = useState(false);
  const [hasNotes, setHasNotes] = useState(false);

  //console.log(CommonUtil.generateRandom(50000));
  //console.log(CommonUtil.generateUUID());
  //the current notes in the notebook
  //const [notes, setNotes] = useState<Note[]>();

  //const data = useLoaderData();
  //const { notes, notebook } = data as NotebookDetailsLoader;

  const location = useLocation();
  // { pathname: "/notebook/details/36", search: "", hash: "", state: null, key: "default" }
  //console.log(location);

  //const navigate = useNavigate();

  // @ts-ignore
  //const notebook = useSelector((state) => state.notebook.value)
  const dispatch = useDispatch();

  //const [currentNotebook, setCurrentNotebook, setShowMessage] = useOutletContext();
  //const {home, setHome} = useHomeContext();

  // @ts-ignore
  const noteFromStore = useSelector((state) => state.note.value)

  const readNote = async (noteId) => {
    const result = await notebookService.readNoteById(noteId);
    setNote(result);
  };

  const handleClear = async () => {
    setNote({ id: undefined, name: "", text: "" });
    setKeyEditor(CommonUtil.generateRandom(50000));
    //console.log(keyEditor);
  };

  //on select note from list load Note information
  const handleNoteDetails = (noteId) => {
    logger.debug("handleNoteDetails noteId:" + noteId);
    dispatch(handleClick({name :'noteId', id: noteId}));
    readNote(noteId);
  };

   useEffect(() => {
      const loadData = async () => {
        let notebookId;
        //read the notes by the notebook selected
        if (location?.state) {
          notebookId = location?.state.id;
        } else if (location?.pathname) {
          notebookId = location.pathname.split("/")[2];
        }
        logger.debug(`load the notes using notebookId:${notebookId}`);
       
       // Parallelize API calls instead of awaiting sequentially (async-parallel)
       const [notebook, notes] = await Promise.all([
         notebookService.readNotebookById(Number(notebookId)),
         notebookService.readNotesByNotebook(Number(notebookId)),
       ]);
       
       dispatch(storeNotebook(notebook));
       dispatch(storeNotes(notes));

       currentNotebook = notebook;
       if (note?.note_book_id !== currentNotebook?.id) {
         setNote({ id: undefined, name: "", text: "" });
       }

       setHasNotes(notes?.length > 0);

       if(noteFromStore){
         setNote(noteFromStore);
       }else {
         handleClear();
       }

     };
     loadData();
   }, [location]);

  const editorRef = useRef(null);

   const onClickSaveBtn = async () => {
     logger.debug("Saving note");

     // @ts-ignore
     const htmlRichText = editorRef.current.getContent();

     //validations
     if (note?.id === undefined && note?.name === "") {
       setMessageText({
         show: true,
         title: "Error",
         message: "the 'name' attribute is required",
       });
       return;
     }

     if (editorRef.current && htmlRichText) {
       setProcessing(true);
       setNoteChance(false);

       if (
         htmlRichText !== undefined &&
         htmlRichText !== "" &&
         note?.text !== htmlRichText
       ) {
         let newNote = { ...note, text: htmlRichText };
         setNote(newNote);
       }

       if (note && note.name && note.text && note.id) {
         logger.debug("updating existing note");
         await notebookService.updateNote({
           name: note?.name,
           text: htmlRichText,
           id: note?.id,
         });
         setProcessing(false);
       }

       if (note?.id === undefined && note?.name !== "") {
         logger.debug("creating new note");
        const newNoteId = await notebookService.createNote({
          name: note?.name,
          text: htmlRichText,
          note_book_id: currentNotebook.id,
        });
        let newNote = { ...note, id: newNoteId, text: htmlRichText };
        setNote(newNote);

        //reload the notes list
        const notes = await notebookService.readNotesByNotebook(
          Number(currentNotebook.id)
        );
        dispatch(storeNotes(notes));

        setProcessing(false);
      }
    } else {
      setMessageText({
        show: true,
        title: "Error",
        message: "there is nothing in the 'note' content",
      });
    }
  };

  const handleNewNoteClick = async () => {
    await notebookService.heartbeat();
    handleClear();
    setEnableEditNote(true);
  };

  const toggleEnableEditNote = async () => {
    await notebookService.heartbeat();
    setEnableEditNote(!enableEditNote);
    if (noteChange) {
      //reload the note
      readNote(note?.id);
    }
  };

  const onEditorChange = async (content) => {
    let ch = content !== note?.text;
    //console.log(ch);
    setNoteChance(ch);
  };

  return (
    <>
      <OffcanvasNotes handleNoteDetails={handleNoteDetails}></OffcanvasNotes>
      <ToastMessage
        model={messageText}
        handleClose={async () => {
          logger.debug("close message");
          setMessageText({ ...messageText, show: false });
        }}
      />

       <div>
         <div className="all-0 absolute">
           <div className={hasNotes ? "has-notes" : "no-notes"}>
             <LastNotes handleSelectNote={handleNoteDetails} />
           </div>
          <div
            className={hasNotes ? "editor-header" : "editor-header-no-notes"}
          >
            <div className="d-flex justify-content-between">
              <div className="block1">
                <div>
                  {/* <button
                    className="btn-icon"
                    onClick={handleClear}
                    title="Clear"
                  >
                    <FontAwesomeIcon icon={faClear} />
                  </button> */}
                  &nbsp;
                </div>
              </div>
              <div className="block2">
                <input
                  type="text"
                  onChange={(e) => {
                    setNote({ ...note, name: e.target.value });
                  }}
                  value={note?.name}
                  className="note-name-input rounded p-1 text-wrap text-center"
                  placeholder="note title"
                />
              </div>
              <div className="block3 d-flex justify-content-end">
              {enableEditNote ? (
              /*<button
                  className={noteChange ? "btn-icon btn-icon-primary" : "btn-icon btn-icon-light"}
                  onClick={onClickSaveBtn}
                  title="Save Note"
                >
                  <FontAwesomeIcon icon={faCloudArrowUp} />
                </button>*/
                <LTButton icon={faCloudArrowUp} title="Save Note"  onClick={onClickSaveBtn} 
                className={noteChange ? "btn-icon-primary" : "btn-icon-light"}/>
              ) :''}
                {processing ? (
                  <LTButton icon={faCheckCircle} title="Saved 2"  />
                ) : (
                  <>
                    
                  <LTButton icon={faSquarePlus} title="New Note 2"  onClick={handleNewNoteClick} />
                    
                    {note?.name !== "" && note?.text !== "" ? (
                      /*<button
                        className="btn-icon"
                        onClick={toggleEnableEditNote}
                        title="Edit Note"
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </button>*/
                      <LTButton icon={faPencil} title="Edit Note 2"  onClick={toggleEnableEditNote} />
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div
            className={hasNotes ? "editor-content" : "editor-content-no-notes"}
          >
            <div className="h-100">
              {enableEditNote ? (
                <LazyEditor
                  key={keyEditor}
                  keyEditor={keyEditor}
                  onEditorChange={onEditorChange}
                  editorRef={editorRef}
                  initialValue={note?.text}
                />
              ) : (
                <NoteView key={note?.id} note={note}></NoteView>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotebookDetailsPage;
